import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 앱 공용 팝업 슬롯 한 칸. type 이 없으면 아무것도 떠 있지 않다 */
export type PopupState = {
    isShow: boolean
    type?: string
    leftCallback?: (...args: never[]) => unknown
    leftParam?: unknown
    rightCallback?: (...args: never[]) => unknown
    rightParam?: unknown
    data?: unknown
}

const EMPTY: PopupState = {
    isShow: false,
    type: undefined,
    leftCallback: undefined,
    leftParam: undefined,
    rightCallback: undefined,
    rightParam: undefined,
    data: undefined,
}

const state: PopupState = { ...EMPTY }

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'setPopup': (store: Store, param: PopupState): void => {
        store.commit('muPopup', param)
    },
    'closePopup': (store: Store): void => {
        store.commit('muPopup', { ...EMPTY })
    },
}

const mutations = {
    'muPopup': (state: PopupState, param: PopupState): void => {
        state.type = param.type
        state.leftCallback = param.leftCallback
        state.leftParam = param.leftParam
        state.rightCallback = param.rightCallback
        state.rightParam = param.rightParam
        state.data = param.data
        state.isShow = param.isShow
    },
}

const popup: Module<PopupState, StoreState> = { state, actions, mutations }

export default popup
